module.exports = __webpack_public_path__ + "static/img/planet3.c6a8fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planet/planet3.png
// module id = AEQ4
// module chunks = 1